import {
  SET_SEARCH_PARAMS_APP_KNOWLEDGE_VERIFICATION,
  GET_DATA_BY_SEARCH_PARAMS_APP_KNOWLEDGE_VERIFICATION,
  ADD_NEW_DATA_APP_KNOWLEDGE_VERIFICATION,
  GET_DATA_BY_INPUT_INFO_KNOWLEDGE_VERIFICATION,
  SAVE_APP_KNOWLEDGE_VERIFICATION,
  CLEAR_STATE_KNOWLEDGE_VERIFICATION,
  GET_DATA_APP_KNOWLEDGE_VERIFICATION_BY_ID,
  SAVE_DATA_FOR_RERENDER_KNOWLEDGE_VERIFICATION,
  SET_NEED_REWRITE,
  CLEAR_ERROR_APP_KNOWLEDGE_VERIFICATION,
} from "../types";

const initialState = {
  data: {},
  searchParams: {
    surname: "",
    name: "",
    midname: "",
    birthDate: "",
    section: 0,
    programId: 0,
  },
  dataForTable: [],
  registrationResult: "",
  appId: "",
  file: "",
  programValid: true,
  dataRerender: {},
  needRewrite: false,
};

export const appKnowledgeVerificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SEARCH_PARAMS_APP_KNOWLEDGE_VERIFICATION:
      return {
        ...state,
        searchParams: Object.assign(state.searchParams, action.data),
      };
    case GET_DATA_BY_SEARCH_PARAMS_APP_KNOWLEDGE_VERIFICATION:
      return {
        ...state,
        dataForTable: action.data,
      };
    case ADD_NEW_DATA_APP_KNOWLEDGE_VERIFICATION:
      return {
        ...state,
        data: { ...state.data, ...action.data },
      };
    case GET_DATA_BY_INPUT_INFO_KNOWLEDGE_VERIFICATION:
      return {
        ...state,
        data: { ...state.data, ...action.data.data },
        programValid: action.data.programValid,
      };
    case SAVE_APP_KNOWLEDGE_VERIFICATION:
      return {
        ...state,
        registrationResult: action.data.registrationResult,
        appId: action.data.appId,
      };
    case CLEAR_STATE_KNOWLEDGE_VERIFICATION:
      return {
        ...state,
        data: {},
        registrationResult: "",
        appId: "",
        file: "",
        programValid: true,
      };
    case GET_DATA_APP_KNOWLEDGE_VERIFICATION_BY_ID:
      return {
        ...state,
        data: { ...state.data, ...action.data },
        file: action.data.medDoc || "",
      };
    case SAVE_DATA_FOR_RERENDER_KNOWLEDGE_VERIFICATION: {
      return {
        ...state,
        data: { ...action.data },
        dataRerender: action.data,
      };
    }
    case SET_NEED_REWRITE: {
      return {
        ...state,
        needRewrite: action.data,
        // dataRerender: action.data ? state.dataRerender : {},
      };
    }
    case CLEAR_ERROR_APP_KNOWLEDGE_VERIFICATION: {
      return {
        ...state,
        registrationResult: "",
        appId: "",
      };
    }
    default:
      return state;
  }
};
